import { Utils } from 'underscore-extensions';
import { canShowLoginButton, handlerClickSignUp } from './studioHeader';

import directives from './module';
import { AuthenticationSvc } from '../services/AuthenticationSvc';
import { UserProjectCountSvc } from '../services/userProjectCount';

export const canShowUpgradeButton = (state: ng.ui.IStateService) => () =>
    options.user.subscriptionDetails.wave.name === 'WaveFree' &&
    !(state.is('wave-pricing') || state.is('studio-pricing'));

class WaveHeader implements ng.IComponentController {
    handlerClickSignUp = handlerClickSignUp('WAVE');
    canShowLoginButton = canShowLoginButton(this.$state);
    canShowUpgradeButton = canShowUpgradeButton(this.$state);
    hasUserProjects = false;

    constructor(
        private $state: ng.ui.IStateService,
        public AuthenticationSvc: AuthenticationSvc,
        private userProjectCountSvc: UserProjectCountSvc
    ) {
        !options.user.anonymous &&
            this.userProjectCountSvc
                .getCount()
                .then(count => (this.hasUserProjects = !!count));
    }

    handlerClickLogin() {
        const redirectParam = `?redirectUrl=${location.href}`;

        return Utils.redirectToReact(`login${redirectParam}`, 'WAVE');
    }
}

directives.component('waveHeader', {
    controller: WaveHeader,
    templateUrl: require('wave-header.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/waveHeader.ts